/* eslint-disable react/jsx-no-bind */
import { useEffect, useState } from 'react';

import Button from '@App/components/Button/Button';

const NEXT_QUESTION_COOLDOWN = 3000;

function QuestionNextButton({ onNext, children, disabled = false }) {
  const [isCoolingDown, setIsCoolingDown] = useState(true);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setIsCoolingDown(false);
    }, NEXT_QUESTION_COOLDOWN);

    return () => window.clearTimeout(timeoutId);
  }, []);

  function handleClick() {
    if (disabled || isCoolingDown) return;

    onNext();
  }

  return (
    <Button
      disabled={disabled || isCoolingDown}
      isLoading={isCoolingDown}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
}

export default QuestionNextButton;
